import React from "react";
import useProducts from "../../../hooks/useProducts";
import { MdDelete } from "react-icons/md";
import { BASE_URL } from "../../../api/rootApi";

const ManageProducts = () => {
  const [products] = useProducts([]);

  const handleDelete = (id) => {
    const confirm = window.confirm("Are you sure to delete product?");
    if (confirm) {
      fetch(`${BASE_URL}/products/${id}`, {
        method: "DELETE",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.deletedCount) {
            alert("Product deleted!");
          }
        });
    }
  };

  return (
    <div className="bg-slate-50 min-h-[calc(100vh-4rem)] py-12">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="mb-10 text-center md:text-left">
          <h2 className="text-3xl font-bold text-slate-900 tracking-tight mb-2">Manage Products</h2>
          <p className="text-slate-500">View and remove pet products gracefully from your inventory.</p>
        </div>

        {products.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {products.map((product) => (
              <div
                key={product?._id}
                className="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col border border-slate-200/60 overflow-hidden hover:-translate-y-1"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-slate-50">
                  <img
                    src={product?.img}
                    alt={product?.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <span className="absolute top-4 left-4 bg-white/95 backdrop-blur text-slate-900 text-sm font-bold px-3.5 py-1.5 rounded-full shadow-sm ring-1 ring-black/5">
                    {product?.price}
                  </span>
                </div>

                <div className="p-6 flex flex-col flex-1">
                  <div className="flex justify-between items-start mb-3 gap-2">
                    <h3 className="text-lg font-bold text-slate-900 line-clamp-1 group-hover:text-amber-500 transition-colors duration-200">
                      {product?.title}
                    </h3>
                  </div>

                  <p className="text-slate-500 leading-relaxed line-clamp-2 flex-1 mb-4 text-sm">
                    {product?.details}
                  </p>

                  <div className="flex items-center gap-2 mb-6">
                    <span className="bg-slate-100 text-slate-700 text-xs font-bold px-2.5 py-1 rounded-md shrink-0 border border-slate-200 shadow-sm">
                      {product?.size}
                    </span>
                  </div>

                  <div className="mt-auto pt-4 border-t border-slate-100">
                    <button
                      onClick={() => handleDelete(product?._id)}
                      className="w-full py-3 rounded-xl bg-slate-900 text-white font-semibold text-sm hover:bg-amber-500 hover:text-slate-900 transition-all duration-300 flex items-center justify-center gap-2"
                    >
                      <MdDelete className="text-lg" />
                      Delete Product
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-slate-200/60 p-16 text-center shadow-sm max-w-2xl mx-auto">
            <div className="text-5xl mb-4">📦</div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">No products found</h3>
            <p className="text-slate-500 mb-6">Your inventory is currently empty. Start adding some new pets or products!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageProducts;
